'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';

// TODO: Use Remove `update: any` for the update method once `useStore` uses `ReadonlyStore`

export const SchedulerStoreContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") SchedulerStoreContext.displayName = "SchedulerStoreContext";
export function useSchedulerStoreContext(optional = false) {
  const context = React.useContext(SchedulerStoreContext);
  if (context == null && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: useSchedulerStoreContext must be used within an <EventCalendar /> or a <EventTimelinePremium /> component' : _formatErrorMessage(213));
  }
  return context;
}